import React from 'react';
import { Row, Col } from 'react-bootstrap'
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';

const Progress = ({ complete, title, number }) => {
  return (
    <div className="c-progress">
      <Row className="align-items-center">
        <Col>
          <CircularProgressbarWithChildren styles={buildStyles({pathColor: `rgb(92, 94, 105)`, trailColor: '#d6d6d6'})} className="c-progress-c" value={complete} strokeWidth={5} counterClockwise>
            {
              complete > 90 && <span className="warn"><img src="/icons/warning-progress-ico.png" alt="" /></span>
            }
            <div className="progress-text">
              <span>{complete}%</span>
              <br/>
              <div className="text-center">{number}</div>
            </div>
          </CircularProgressbarWithChildren>
        </Col>
        <Col className="text-left">
          <h6>{title}</h6>
        </Col>
      </Row>
    </div>
  )
}

export default Progress;